import { loadAnnouncementImagePreviewAPI } from '@/service';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AnnouncementImageContentRequest } from '@/model';

const loadAnnouncementImagePreviewBaseQueryKey = 'loadAnnouncementImagePreview';
const loadAnnouncementImagePreviewQueryKey = (
  request: AnnouncementImageContentRequest,
) => [loadAnnouncementImagePreviewBaseQueryKey, request];

const loadAnnouncementImagePreviewFetchFunction = loadAnnouncementImagePreviewAPI;

export const useLoadAnnouncementImagePreviewQuery = (
  request: AnnouncementImageContentRequest,
) => {
  return useQuery({
    queryKey: loadAnnouncementImagePreviewQueryKey(request),
    queryFn: () => loadAnnouncementImagePreviewFetchFunction(request),
    select: (response) => response?.data,
    placeholderData: keepPreviousData,
  });
};
